export default __webpack_public_path__ + "static/media/buildings-inactive.e70de9ea.png";